import api from "../api/api";

export const USER_SESSION = "USER_SESSION";
export const UNMNG_SCTR_GB_LIST = [
  "005",
  "007",
  "008",
  "009",
  "010",
  "011",
  "014",
  "015",
];
// export const EMPTY_CMPNY_LIST = [44, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787, 788, 789, 790, 791];
// const emptyCmpny = EMPTY_CMPNY_LIST.includes(user.companySeq);
export const INIT_PSWRD = "0000";

export function findByPhoneOrUserId(phoneOrUserId: string, callback: any) {
  api
    .findByPhoneOrUserId(phoneOrUserId)
    .then((r: boolean) => {
      callback(r);
    })
    .catch(console.error);
}

export async function login(phoneOrUserId: any, userAuth: any, inputPassword:any, callback: any) {
  await api
    .login(phoneOrUserId, userAuth, inputPassword)
    .then((user) => {
      sessionStorage.setItem(USER_SESSION, JSON.stringify(user));
      callback(user);
    })
    .catch(console.error);
}
export function logout() {
  // eslint-disable-next-line no-restricted-globals
  if (confirm("로그아웃 하시겠습니까?")) {
    if (sessionStorage.getItem(USER_SESSION) !== null) {
      sessionStorage.removeItem(USER_SESSION);
    } else if (localStorage.getItem(USER_SESSION) !== null) {
      localStorage.removeItem(USER_SESSION);
    }
    window.location.href = "/";
  }
}
export function logoutWC() {
  if (sessionStorage.getItem(USER_SESSION) !== null) {
    sessionStorage.removeItem(USER_SESSION);
  } else if (localStorage.getItem(USER_SESSION) !== null) {
    localStorage.removeItem(USER_SESSION);
  }
  window.location.href = "/";
}
export function getLoginUser() {
  var user = localStorage.getItem(USER_SESSION)
    ? localStorage.getItem(USER_SESSION)
    : sessionStorage.getItem(USER_SESSION);
  if (user === null) {
    return null;
  }
  return JSON.parse(user);
}

export function loginByKakaoId(kakaoId: string, callback: any) {
  api
    .checkKakaoId(kakaoId)
    .then((user) => {
      sessionStorage.setItem(USER_SESSION, JSON.stringify(user));
      callback(user);
    })
    .catch(console.error);
}

// export function loginByPhone(phone: string, callback: any) {
//     api
//         .checkPhone(phone)
//         .then((user) => {
//             sessionStorage.setItem(USER_SESSION, JSON.stringify(user));
//             callback(user);
//         })
//         .catch(console.error);
// }

// export async function rememberLogin(
//   phoneOrUserId: any,
//   password: any,
//   callback: any
// ) {
//   await api
//     .login(phoneOrUserId, password)
//     .then((user) => {
//       localStorage.setItem(USER_SESSION, JSON.stringify(user));
//       callback(user);
//     })
//     .catch(console.error);
// }